import React from 'react'
import getCssVariable from '../../App/validation/getCssVariable'
import { useDispatch, useSelector } from 'react-redux';
import { set_value_toolbox } from '../../App/actions/toolboxActions';
import { set_value_layer } from '../../App/actions/layerActions';
import { status_action } from '../../App/actions/mapActions';
import { post_activities } from '../../App/actions/activities';

function TOOLBOX_SELECTION(props) {
  const { name, tools } = props || {}
  const dispatch = useDispatch();

  const { map_object, draw_object } = useSelector((state) => state.layer)
  const toolbox = useSelector((state) => state.toolbox);

  const on_draw = (tool) => {
    //state management draw
    dispatch(set_value_layer({
      key: "draw_state_platform",
      value: "toolbox",
    }));
    dispatch(set_value_layer({
      key: "geometryStatus",
      value: false,
    }));

    const mode_draw = tool?.mode;

    dispatch(set_value_toolbox({
      key: "mode_draw",
      value: mode_draw,
    }));

    dispatch(status_action());

    //bagian map
    if (map_object && mode_draw && draw_object) {
      map_object.getCanvas().style.cursor = "crosshair";
      draw_object.changeMode(mode_draw);
    }
  };

  const on_change_mode_toolbox = (tool) => {
    const {
      key,
      name,
      is_need_toolbox_companion,
      description,
      name_id,
      uuid_name,
      is_need_setting
    } = tool

    dispatch(set_value_layer({
      key: "layer_id_active",
      value: [],
    }))
    dispatch(set_value_layer({
      key: "layer_id",
      value: "",
    }))

    dispatch(set_value_toolbox({
      key: "start_time",
      value: new Date(),
    }));
    const toolbox_type = key.replace("features_", "").replace("scoring_", "");
    dispatch(post_activities({ action: `toolbox-${toolbox_type}`, duration_ms: 0 }));

    //ganti props
    dispatch(set_value_toolbox({
      key: "mode_toolbox",
      value: key,
    }));
    dispatch(set_value_toolbox({
      key: "selected_row_toolbox_ids",
      value: [],
    }));
    dispatch(set_value_toolbox({
      key: "name_id",
      value: name_id,
    }));
    dispatch(set_value_layer({
      key: "draw_state_platform",
      value: "",
    }));

    dispatch(set_value_toolbox({
      key: "uuid_name",
      value: uuid_name,
    }));

    dispatch(set_value_toolbox({
      key: "description",
      value: description,
    }));
    dispatch(set_value_toolbox({
      key: "is_need_toolbox_companion",
      value: is_need_toolbox_companion,
    }));
    dispatch(set_value_toolbox({
      key: "is_need_setting",
      value: is_need_setting,
    }));
    dispatch(set_value_toolbox({
      key: "name_toolbox",
      value: name,
    }));

    const features = toolbox[key];
    const last_saved = features?.at(-1)?.properties?.uuid || "start";
    dispatch(set_value_toolbox({
      key: "last_saved_feature_uuid",
      value: last_saved,
    }));

    dispatch(status_action());

    // //reset draw map
    // if (map_object) {
    //   map_object.getCanvas().style.cursor = "";
    //   if (draw_object) {
    //     dispatch(set_value_toolbox({
    //       key: "mode_draw",
    //       value: "simple_select",
    //     }));
    //     draw_object.changeMode("simple_select");
    //   }
    // }

    on_draw(tool);
  };

  return (
    <div
      name={name}
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        rowGap: "30px",
        maxWidth: "253px"
      }}
    >
      {tools.map(tool => (
        <button
          key={tool.name}
          style={{
            display: "flex",
            justifyContent: "center",
            cursor: "pointer",
            borderRadius: "10px",
            padding: `5px 0 5px 0`,
            height: tool?.is_long_text ? "110px" : "93px",
          }}
          onClick={() => on_change_mode_toolbox(tool)}
        >
          <div>
            {/* IMAGE + BADGE */}
            <section
              style={{
                position: "relative", // ⬅️ penting
                marginBottom: "11px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {/* NEW BADGE */}
              {tool.is_new && (
                <div
                  style={{
                    position: "absolute",
                    height: "17px",
                    width: "29px",
                    top: "-6px",
                    right: "1px",
                    fontSize: "9px",
                    borderRadius: "5px",
                    backgroundColor: getCssVariable("--accent"),
                    color: getCssVariable("--base"),
                    fontWeight: "700",
                    zIndex: 2,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                  New
                </div>
              )}

              {/* ICON */}
              {tool?.icon && <div
                style={{
                  borderRadius: "15px",
                  border: "1px solid #ABABAB",
                  width: "55px",
                  height: "55px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={tool?.icon} alt={tool?.name} />
              </div>}
            </section>

            {/* LABEL */}
            <section
              style={{
                textAlign: "center",
                width: "71px",
                fontSize: "14px",
              }}
            >
              <label>{tool.name}</label>
            </section>
          </div>
        </button>
      ))}
    </div>
  )
}

export default TOOLBOX_SELECTION